import get from 'lodash.get';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { sortByPublishDate } from '../../tools/mappers';
import { ArrowLink } from '../Common/Links';
import BlogCard from './BlogCard';
import * as styles from './BlogPostListing.module.css';

const BlogPostListing = ({ blogPosts, dark = false }) => {
  const POSTS_PER_PAGE = 9;
  const postCount = POSTS_PER_PAGE;
  const [postAmount, setPostAmount] = useState(POSTS_PER_PAGE);
  const hasMore = postAmount < get(blogPosts, 'length', 0);
  const posts = blogPosts.sort(sortByPublishDate).slice(0, postAmount);

  return (
    <>
      <div className={[styles.posts, dark ? styles.dark : ''].join(' ')}>
        {posts.map((post, i) => {
          const gatsbyImageData = get(post, 'heroImage.gatsbyImageData');
          const img = get(post, 'heroImage.file.url');

          return (
            <BlogCard
              key={i}
              gatsbyImageData={gatsbyImageData}
              img={img}
              slug={get(post, 'slug', '')}
              title={get(post, 'title', '')}
              description={get(post, 'articleDescription.articleDescription', '')}
              author={get(post, 'author.name', '')}
              date={get(post, 'publishDate', '')}
              readTime={post.readTime}
            />
          );
        })}
      </div>
      {hasMore && (
        <div className={[styles.loadMore, dark ? styles.darkArrow : ''].join(' ')}>
          <ArrowLink label={'Load more'} onClick={() => setPostAmount(postAmount + postCount)} isArrowDown isLarge />
        </div>
      )}
    </>
  );
};

BlogPostListing.propTypes = {
  blogPosts: PropTypes.array.isRequired,
};

export default BlogPostListing;
